/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
 document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('utm_source');
  const content = urlParams.get('utm_content');
  const med = urlParams.get('utm_medium');
  const idRef = urlParams.get('sca_ref');
  const uppId = idRef ? 'affiliate_' + idRef.split('.')[0] : null;
  const unformattedAffiliateId = urlParams.get('utm_campaign');
  const affiliateId = unformattedAffiliateId && !unformattedAffiliateId.startsWith('affiliate_') ? 'affiliate_' + unformattedAffiliateId : unformattedAffiliateId;
  const refParam = urlParams.get('ref');
  const pageRef = document.referrer;
  //console.log(pageRef);
  const getPath = window.location.pathname;
   //console.log(getPath);
  const validPathsSet = new Set([
    '/pages/aisecold', '/pages/haroldleffall', '/pages/juicefeaster', '/pages/getwellwithelle',
    '/pages/juicingwithja', '/pages/juicingtutorials', '/pages/italeatsandtreats', '/pages/healthyveganeating',
    '/pages/laurenmattice', '/pages/munching_meals', '/pages/itsherwellness', '/pages/brandonahmaud',
    '/pages/littlekalegirl', '/pages/jucbynature', '/pages/jefeharris', '/pages/casinocrisis', '/pages/pmh',
    '/pages/growyourown'
  ]);

  const affiliateMessages = {
    'affiliate_3600889': { affCde: 'BESTKITCHEN', affPage: '' },
    'affiliate_2497517': { affCde: 'BESTKITCHEN', affPage: '' },
    'affiliate_699287': { affCde: 'VANESSA', affPage: '' },
    'affiliate_2028197': { affCde: 'VANESSA', affPage: '' },
    'affiliate_3485080': { affCde: 'HEALTHYVEGAN', affPage: '/pages/healthyveganeating' },
    'affiliate_1961139': { affCde: 'HEALTHYVEGAN', affPage: '/pages/healthyveganeating' },
    'affiliate_2568826': { affCde: 'BRANDON', affPage: '/pages/brandonahmaud' },
    'affiliate_2113867': { affCde: 'BRANDON', affPage: '/pages/brandonahmaud' },
    'affiliate_3402603': { affCde: 'SAVRAJ', affPage: '' },
    'affiliate_3344098': { affCde: 'AMEE', affPage: '' },
    'affiliate_3344273': { affCde: 'TUTORIALS', affPage: '/pages/juicingtutorials' },
    'affiliate_2497519': { affCde: 'TUTORIALS', affPage: '/pages/juicingtutorials' },
    'affiliate_3335124': { affCde: 'AISECOLD', affPage: '/pages/aisecold' },
    'affiliate_8670444': { affCde: 'AISECOLD', affPage: '/pages/aisecold' }, 
    'affiliate_2497487': { affCde: 'AISECOLD', affPage: '/pages/aisecold' },    
    'affiliate_3321966': { affCde: 'JUICEGUY', affPage: '/pages/haroldleffall' },
    'affiliate_2497547': { affCde: 'JUICEGUY', affPage: '/pages/haroldleffall' },
    'affiliate_3295249': { affCde: 'MUNCHING', affPage: '/pages/munching_meals' },
    'affiliate_2497573': { affCde: 'MUNCHING', affPage: '/pages/munching_meals' },
    'affiliate_3294725': { affCde: 'IAMWELL', affPage: '/pages/getwellwithelle' },
    'affiliate_2497497': { affCde: 'IAMWELL', affPage: '/pages/getwellwithelle' },
    'affiliate_2511078': { affCde: 'ANDREA', affPage: '' },
    'affiliate_2762117': { affCde: 'SAVAGEJUICE', affPage: '' },
    'affiliate_2207369': { affCde: 'SAVAGEJUICE', affPage: '' },
    'affiliate_3247134': { affCde: 'THECURLYVEGAN', affPage: '' },
    'affiliate_2132905': { affCde: 'THECURLYVEGAN', affPage: '' },
    'affiliate_2959023': { affCde: 'NATURALVEGAN', affPage: '' },
    'affiliate_1963137': { affCde: 'NATURALVEGAN', affPage: '' },
    'affiliate_1461752': { affCde: 'DRIP', affPage: '' },
    'affiliate_2497525': { affCde: 'DRIP', affPage: '' },
    'affiliate_2744951': { affCde: 'JUICINGWITHJA', affPage: '/pages/juicingwithja' },
    'affiliate_2512875': { affCde: 'LITTLEKALEGIRL', affPage: '/pages/littlekalegirl' },
    'affiliate_7479522': { affCde: 'LITTLEKALEGIRL', affPage: '/pages/littlekalegirl' },
    'affiliate_2497505': { affCde: 'LITTLEKALEGIRL', affPage: '/pages/littlekalegirl' },
    'affiliate_1340986': { affCde: 'OLIVIA', affPage: '' },
    'affiliate_2500959': { affCde: 'JKJUICES', affPage: '/pages/laurenmattice' },
    'affiliate_2497523': { affCde: 'JKJUICES', affPage: '/pages/laurenmattice' },
    'affiliate_2376929': { affCde: 'JUICEFEASTER', affPage: '/pages/juicefeaster' },
    'affiliate_2131663': { affCde: 'JUICEFEASTER', affPage: '/pages/juicefeaster' },
    'affiliate_4162728': { affCde: 'KATARINA', affPage: '' },
    'affiliate_4183200': { affCde: 'GRASSROOTS', affPage: '' },
    'affiliate_4221658': { affCde: 'OLIVIA', affPage: '' },
    'affiliate_4229821': { affCde: 'JUCBYNATURE', affPage: '/pages/jucbynature' },
    'affiliate_4261073': { affCde: 'JUICEDORGANICS', affPage: '' },
    'affiliate_4261420': { affCde: 'BESTCUT', affPage: '' },
    'affiliate_4285778': { affCde: 'MELLOW', affPage: '' },
    'affiliate_4285928': { affCde: 'CASINOCRISIS', affPage: '/pages/casinocrisis' },
    'affiliate_4359281': { affCde: 'GROWYOUROWN', affPage: '/pages/growyourown' },
    'affiliate_4361751': { affCde: 'ABI', affPage: '' },
    'affiliate_4417726': { affCde: 'MAYA', affPage: '' },
    'affiliate_4423468': { affCde: 'MASCIOS', affPage: '' },
    'affiliate_4532092': { affCde: 'ERIKA', affPage: '' },
    'affiliate_4545748': { affCde: 'ATRAVELINGTREAT', affPage: '' },
    'affiliate_4845941': { affCde: 'JEFE', affPage: '/pages/jefeharris' },
    'affiliate_4871594': { affCde: 'PMH', affPage: '/pages/pmh' },
    'affiliate_4992465': { affCde: 'MATTKITCHEN', affPage: '' },
    'affiliate_5022784': { affCde: 'ANTOHNY', affPage: '' },
    'affiliate_5333156': { affCde: 'LEXI', affPage: '' },
    'affiliate_5467015': { affCde: 'FOODIEGUIDE', affPage: '' },
    'affiliate_6440426': { affCde: 'CANDICE', affPage: '' },
    'affiliate_6612439': { affCde: 'veganscratchkitchen', affPage: '' },
    'affiliate_6905607': { affCde: 'RONNEB', affPage: '' },
    'affiliate_6952934': { affCde: 'NATURALVEGAN', affPage: '' },
    'affiliate_7052187': { affCde: 'DREW', affPage: '' },
    'affiliate_7052187': { affCde: 'DREW', affPage: '' },
    'affiliate_7062402': { affCde: 'JUICINGWITHJA', affPage: '/pages/juicingwithja' },
    'affiliate_2497509': { affCde: 'JUICINGWITHJA', affPage: '/pages/juicingwithja' },
    'affiliate_7187260': { affCde: 'DBK', affPage: '' },
    'affiliate_7484203': { affCde: 'MEG', affPage: '' },
    'affiliate_2065777': { affCde: 'MEG', affPage: '' },
    'affiliate_7206153': { affCde: 'NEEK', affPage: '/pages/itsherwellness' },
    'affiliate_7206153': { affCde: 'NEEK', affPage: '/pages/itsherwellness' },
    'affiliate_2068183': { affCde: 'NEEK', affPage: '/pages/itsherwellness' },
    'affiliate_7254117': { affCde: 'ITALEATS', affPage: '/pages/italeatsandtreats' },
    'affiliate_3444959': { affCde: 'ITALEATS', affPage: '/pages/italeatsandtreats' },
    'affiliate_2497539': { affCde: 'ITALEATS', affPage: '/pages/italeatsandtreats' },
    'affiliate_9031653': { affCde: 'cupfullofyum', affPage: '' },
    'affiliate_9466214': { affCde: 'LINGANDLAMB', affPage: '' },
    'affiliate_4405184': { affCde: 'DEDETABLE', affPage: '' }
  };
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };

  const setCookie = (name, value, expiry = 3600) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${new Date(Date.now() + expiry * 1000).toUTCString()}`;
  };

  const showAffiliateCode = (code) => {
    //console.log(code);
    const element = document.querySelector('.announcement-bar__item:not([hidden]) .announcement-bar__message p');
    
    if (code && code !== 'mapping issue') {
    element.innerHTML = `Save 10% with code <strong>${code.toUpperCase()}</strong>`;
     }
  };
   if ((source == 'ShareASale' || source === 'upp') && (med == 'Affiliate' || med == 'affiliate')) {
    //console.log('block1');
    const codeText = affiliateMessages[affiliateId]?.affCde || 'mapping issue';
    setCookie("kuvingsbfcmaffcde", codeText);
    setCookie("kuvingsbfcmaffid", affiliateId);
    const cookieValue = getCookie("kuvingsbfcmaffcde");
    showAffiliateCode(cookieValue);
  } else if ((source == 'affiliate') && (content == 'upprom')) {
    const codeText = affiliateMessages[uppId]?.affCde || 'mapping issue';
    setCookie("kuvingsbfcmaffcde", codeText);
    setCookie("kuvingsbfcmaffid", uppId);
    const cookieValue = getCookie("kuvingsbfcmaffcde");
    showAffiliateCode(cookieValue);
  } else if (['google', 'fb', 'ig','friendbuy'].includes(source) && med) {
    setCookie("kuvingsbfcmaffcde", '', -1);  // Expire cookie
    setCookie("kuvingsbfcmaffid", '', -1);  // Expire cookie
  } else if (!pageRef && !source && !med && !refParam && !validPathsSet.has(getPath) && (getPath != '/pages/johnkohler' )) {
    //console.log('cookie reset block executing');
    setCookie("kuvingsbfcmaffcde", '', -1);  // Expire cookie
    setCookie("kuvingsbfcmaffid", '', -1);  // Expire cookie
  } else if (validPathsSet.has(getPath)) {
     //console.log('affiliate page');
    const matchedAffiliate = Object.values(affiliateMessages).find(a => a.affPage === getPath);
    if (matchedAffiliate) {
      const codeText = matchedAffiliate.affCde ;
      setCookie("kuvingsbfcmaffcde", codeText);
      const cookieValue = getCookie("kuvingsbfcmaffcde");
      showAffiliateCode(cookieValue);
    }
  } else if((refParam === 'discountjuicers') || (getPath == '/pages/johnkohler')) {
   // console.log('block john');
    setCookie("kuvingsbfcmaffcde", 'dj');
    setCookie("kuvingsbfcmaffid", 'johnkohler');
    const cookieValue = getCookie("kuvingsbfcmaffcde");
    showAffiliateCode(cookieValue);
  } else {
       // console.log('else');
    const cookieValue = getCookie("kuvingsbfcmaffcde");
    showAffiliateCode(cookieValue);
  }
});

